module.exports = __webpack_public_path__ + "img/f765eb3.jpg";